import './Introducao.css'

import Container from 'react-bootstrap/Container';
import CaixaArredondada from '../CaixaArredondada';

const Introducao = (props) => {
    if(props.linguagem == "pt"){
        return (
            <Container>
                <div className='txt_inicial'>
                        <div className="txt_head_small">
                            UM SISTEMA DIRECIONADO A DADOS PARA ALERTA ANTECIPADO
                            <br></br>
                            DE SURTOS DE DOENÇAS VIRAIS RESPIRATÓRIAS CONTRIBUINDO PARA A PREPARAÇÃO CONTRA EPIDEMIAS.
                        </div>
                    <div className='subtitulo'>
                        <h1 className="cor_diferenciada sombra_diferenciada">SISTEMA DE ALERTA PRECOCE DE SURTOS</h1>
                        <h1>COM POTENCIAL DE PANDEMIA</h1>
                    </div>
                </div>
                <div className="txt_introducao">
                    <div>
                        <img src="imagens/corona_dest.png" className="img-corona" alt="Corona Desenho"/>
                    </div>
                    <div className="lang-pt">
                        <div className='subtitulo cor_diferenciada sombra_diferenciada'>
                            <h3>
                                PARA QUE SERVE O ÆSOP ?
                            </h3>         
                        </div>
                        <div className='cor_diferenciada sombra_diferenciada'>
                            ÆSOP aborda as fases inicias de um surto, tentando entender as forças complexas que operam em seu início e propagação. A disseminação mundial de uma doença infecciosa requer uma alta taxa de transmissão e uma população imunologicamente virgem.
                        </div>
                        <div>
                            Essas condições são mais prováveis para novos agentes infecciosos, especialmente vírus respiratórios zoonóticos. Agentes insidiosos com uma alta proporção de indivíduos assintomáticos infectados sobre casos clinicamente identificados têm maior probabilidade de cruzar furtivamente os sistemas de vigilância tradicionais, permitindo uma extensa progressão. Assumimos que uma infecção viral respiratória tem a maior probabilidade de atingir proporções pandêmicas em um mundo atualmente altamente conectado. <i>VEJA MAIS</i>
                        </div>
                    </div>
                </div>
            </Container>
        )
    } else if(props.linguagem == "en") {
        return (
            <div>
                <div className='txt_inicial'>
                        <div className="txt_head_small">
                            A DATA-DRIVEN SYSTEM FOR EARLY-WARNING
                            <br></br>
                            OF RESPIRATORY VIRAL DISEASE OUTBREAKS CONTRIBUTING TO PREPAREDNESS AGAINST EPIDEMICS
                        </div>
                    <div className='subtitulo'>
                        <h1 className="sombra_diferenciada">ALERT-EARLY SYSTEM OF OUTBREAKS</h1>
                        <h1>WITH PANDEMIC POTENTIAL</h1>
                    </div>
                </div>
                <div className="txt_introducao">
                    <div className='introducao_alinhamento'>
                        <div>
                            <img src="imagens/corona_dest.png" className="img-corona" alt="Corona Desenho"/>
                        </div>
                        
                        <div className="lang-en">
                            <div className='subtitulo cor_diferenciada'>
                                <h3>
                                    WHAT IS ÆSOP INTENDED FOR?
                                </h3>         
                            </div>
                            <div className='cor_diferenciada'>
                                ÆSOP addresses the initial phases of an outbreak, trying to understand the complex forces operating in its initiation and spreading. Worldwide dissemination of an infectious disease requires a high transmission rate and an immunologically naïve population.
                            </div>
                            <div>
                                These conditions are most likely for new infectious agents, especially zoonotic respiratory viruses. Insidious agents with a high ratio of infected symptomless individuals over clinically identified cases have a higher probability of cruising stealthily of traditional surveillance systems, allowing for an extensive progression. We assume that a respiratory viral infection has the highest likelihood of achieving pandemic proportions in a presently highly connected World. <i>SEE MORE</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Introducao